import MyComputer from '../applications/MyComputer';
import MyDocuments from '../applications/MyDocuments';
import RecycleBin from '../applications/RecycleBin';
import Winamp from '../applications/Winamp';
import Paint from '../applications/Paint';
import AIBot from '../applications/AIBot';
import Resume from '../applications/Resume';
import PhotoBooth from '../applications/PhotoBooth';

export const APP_REGISTRY = {
    'my-computer': {
        id: 'my-computer',
        title: 'My Computer',
        icon: '/my-computer.ico',
        component: MyComputer,
        defaultSize: { width: 600, height: 500 },
        initialPosition: { x: 16, y: 100 },
        isNative: false,
    },
    'my-documents': {
        id: 'my-documents',
        title: 'My Documents',
        icon: '/documents.ico',
        component: MyDocuments,
        defaultSize: { width: 600, height: 500 },
        initialPosition: { x: 16, y: 184 },
        isNative: false,
    },
    'recycle-bin': {
        id: 'recycle-bin',
        title: 'Recycle Bin',
        icon: '/recycle-bin.ico',
        component: RecycleBin,
        defaultSize: { width: 600, height: 500 },
        initialPosition: { x: 16, y: 16 },
        isNative: false,
    },
    'resume': {
        id: 'resume',
        title: 'Vimarsh_Tiwari_Resume.pdf',
        icon: '/documents.ico', // Using documents icon as per original code
        label: 'Resume.pdf', // Special label for desktop icon
        component: Resume,
        defaultSize: { width: 600, height: 500 },
        initialPosition: { x: 16, y: 268 },
        isNative: false,
    },
    'winamp': {
        id: 'winamp',
        title: 'Winamp',
        icon: '/winamp.png',
        component: Winamp,
        initialPosition: { x: 16, y: 352 },
        isNative: true,
    },
    'paint': {
        id: 'paint',
        title: 'untitled - Paint',
        icon: '/paint.webp',
        component: Paint,
        initialPosition: { x: 16, y: 436 },
        isNative: true,
    },
    'ai-bot': {
        id: 'ai-bot',
        title: 'AI Bot - Chat with Vimarsh',
        icon: '/vimarshpop.png',
        component: AIBot,
        defaultSize: { width: 600, height: 500 },
        initialPosition: { x: 16, y: 520 },
        isNative: false,
    },
    'image-generator': {
        id: 'image-generator',
        title: 'AI Photo Booth',
        icon: '/paint.webp',
        label: 'AI Photo Booth',
        component: PhotoBooth,
        defaultSize: { width: 600, height: 500 },
        initialPosition: { x: 16, y: 604 },
        isNative: false,
    },
};

export const NATIVE_APP_TYPES = Object.values(APP_REGISTRY)
    .filter(app => app.isNative)
    .map(app => app.id);
